import React, { FC } from 'react';

import { EmbeddedScene, SceneFlexItem, SceneFlexLayout, SceneTimeRange } from '@grafana/scenes';
import { useStyles2 } from '@grafana/ui';

import { css } from '@emotion/css';

import { Analysis, Investigation } from 'types';

import { getInvestigationTimeline } from '../InvestigationTimeline';

// Component Props Interface
interface Props {
  title?: string;
  investigation?: Investigation;
  analyses?: Analysis[];
}

// Declare Component
export const Timeline: FC<Props> = ({ investigation, analyses }) => {
  const styles = useStyles2(getStyles);

  // if investigation is not provided, return null
  if (!investigation || !analyses) {
    return null;
  }

  const inputs = investigation.inputs || [];
  const metricInputs = inputs.filter((input) => input.type === 'metric-query');
  const labelInputs = inputs.filter((input) => input.type === 'label');

  const sceneTimeRange = new SceneTimeRange({
    from: investigation.timeRange.from.format(),
    to: investigation.timeRange.to.format(),
  });

  const timeline = getInvestigationTimeline(
    metricInputs,
    labelInputs,
    sceneTimeRange,
    investigation.timeRange,
    investigation.datasources.prometheusDatasource.uid,
    analyses
  );

  const scene = new EmbeddedScene({
    body: new SceneFlexLayout({
      direction: 'row',
      children: [
        new SceneFlexItem({
          body: timeline,
          minHeight: 200,
        }),
      ],
    }),
  });

  return (
    <div className={styles.container}>
      <scene.Component model={scene} />
    </div>
  );
};

const getStyles = () => {
  return {
    container: css`
      min-height: 50px;
    `,
  };
};

// Export Component
export default Timeline;
